// copied this code from NewConditionDrawer/utils here
// delete the previous one after conditiona are refactored

const regenerateRule = (initialRule, newRuleMap) => {
  const final = initialRule.replace(/[A-Z]+/g, (match) => newRuleMap[match]);
  return final;
};

export default regenerateRule;
